import { reportUrl, invoiceConclusionsUrl, dashboardURL } from "../Config/Url";
import axios from "axios";
import CryptoJS from "crypto-js";

export const reportService = {
  invoicesView,
  invoicesConclusionView,
  invoicesConclusionInvoices,
  invoicesConclusionPayment,
  invoicesConclusionPp,
  invoicesConclusionTaxRates,
  invoicesConclusionPn,
  invoicesConclusionUsers,
  invoicesList,
  invoicesTotalDay,
  invoicesTotalTaxRate,
  invoicesTotalUser,
  invoicesTotalProduct,
  invoiceDetail,
  invoicesTotalPp,
  invoicesTotalPn,
  invoicesMonth,
  invoicesUnfiscal,
  invoicesTotalUnfiscal,
  invoicesUnfiscalDetails,
  fiscalizeInvoices,
  totalOverview,
  totalOverviewItems,
  fixInvoice,
  invoiceTipsList,
};

async function invoicesView({
  tenantId,
  storeTag,
  posTag,
  partnerGuid,
  userGuid,
  fromIssuedTime,
  toIssuedTime,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${reportUrl}search/invoices`, {
      tenantId,
      storeTag,
      posTag,
      fromIssuedTime,
      toIssuedTime,
      partnerGuid,
      userGuid,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function invoiceDetail(invoiceGuid) {
  return axios
    .put(`${reportUrl}${invoiceGuid}`)
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function invoicesList({
  tenantId,
  posId,
  storeId,
  from,
  to,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${reportUrl}search/invoiceslist`, {
      tenantId,
      posId,
      from,
      to,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function invoicesTotalDay({
  tenantId,
  posId,
  storeId,
  from,
  to,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${reportUrl}search/total/day`, {
      tenantId,
      posId,
      from,
      to,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicesTotalPp({
  tenantId,
  posId,
  storeId,
  from,
  to,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${reportUrl}search/total/PP`, {
      tenantId,
      posId,
      from,
      to,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicesTotalPn({
  tenantId,
  posId,
  storeId,
  from,
  to,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${reportUrl}search/total/PN`, {
      tenantId,
      posId,
      from,
      to,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicesTotalProduct({
  tenantId,
  posId,
  storeId,
  from,
  to,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${reportUrl}search/total/product`, {
      tenantId,
      posId,
      from,
      to,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicesTotalTaxRate({
  tenantId,
  posId,
  storeId,
  from,
  to,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${reportUrl}search/total/taxrate`, {
      tenantId,
      posId,
      from,
      to,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicesTotalUser({
  tenantId,
  posId,
  storeId,
  from,
  to,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${reportUrl}search/total/user`, {
      tenantId,
      posId,
      from,
      to,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicesConclusionView({
  tenantId,
  storeId,
  posId,
  fromIssuedTime,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${invoiceConclusionsUrl}/search`, {
      tenantId,
      posId,
      date: fromIssuedTime,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicesConclusionInvoices({ guid, pageIndex, pageSize }) {
  return axios
    .put(`${invoiceConclusionsUrl}/search/invoices`, {
      invoiceConclusionGuid: guid,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicesConclusionPp({ guid, pageIndex, pageSize }) {
  return axios
    .put(`${invoiceConclusionsUrl}/search/pp`, {
      invoiceConclusionGuid: guid,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function invoicesConclusionPayment({ guid, pageIndex, pageSize }) {
  return axios
    .put(`${invoiceConclusionsUrl}/search/payments`, {
      invoiceConclusionGuid: guid,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function invoicesConclusionTaxRates({ guid, pageIndex, pageSize }) {
  return axios
    .put(`${invoiceConclusionsUrl}/search/taxrates`, {
      invoiceConclusionGuid: guid,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function invoicesConclusionPn({ guid, pageIndex, pageSize }) {
  return axios
    .put(`${invoiceConclusionsUrl}/search/pn`, {
      invoiceConclusionGuid: guid,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function invoicesConclusionUsers({ guid, pageIndex, pageSize }) {
  return axios
    .put(`${invoiceConclusionsUrl}/search/users`, {
      invoiceConclusionGuid: guid,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function invoicesMonth({
  tenantId,
  posId,
  from,
  to,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${reportUrl}search/invoicesmonth`, {
      tenantId,
      posId,
      from,
      to,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicesUnfiscal(tenantId, pageIndex, pageSize, tenantOnly) {
  return axios
    .get(
      `${reportUrl}unfiscal?${
        tenantId ? "tenantId=" + tenantId : ""
      }&pageIndex=${pageIndex}&pageSize=${pageSize}&tenantOnly=${tenantOnly}`
    )
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicesTotalUnfiscal(tenantId, token) {
  const urlId = tenantId > 0 ? tenantId : "";
  return axios
    .get(`${dashboardURL}/notFiscalInvoices?tenantId=${urlId}`, {
      headers: {
        Authorization: CryptoJS.AES.decrypt(
          token,
          process.env.REACT_APP_HASH_KEY
        ).toString(CryptoJS.enc.Utf8),
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicesUnfiscalDetails(tenantId, pageIndex, pageSize) {
  return axios
    .get(
      `${reportUrl}unfiscal-details?tenantId=${tenantId}&pageIndex=${pageIndex}&pageSize=${pageSize}`
    )
    .then((res) => res)
    .catch((err) => err);
}

async function fiscalizeInvoices() {
  var config = {
    method: "get",
    url: "http://afb.northeurope.cloudapp.azure.com:82/api/v1/Fiscal/auto",
    headers: {
      "X-FiscalToken": "lFzLM6rsZhOAmWplY5xU",
    },
  };
  return axios(config)
    .then((res) => res)
    .catch((err) => err);
}

async function totalOverview(
  tenantId,
  storeTag,
  posTag,
  partnerGuid,
  from,
  to
) {
  return axios
    .put(`${reportUrl}search/invoicesTaxesInfo`, {
      tenantId,
      storeTag,
      posTag,
      partnerGuid,
      from,
      to,
      pageIndex: 0,
      pageSize: 0,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function totalOverviewItems(
  tenantId,
  storeTag,
  posTag,
  partnerGuid,
  from,
  to
) {
  return axios
    .put(`${reportUrl}search/invoicesProductInfo`, {
      tenantId,
      storeTag,
      posTag,
      partnerGuid,
      from,
      to,
      pageIndex: 0,
      pageSize: 0,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function fixInvoice(id) {
  return axios
    .get(
      `https://premiumfb.telekomcloud.hr:8800/api/v1/Fiscal/storno-fiscal?invoiceGuid=${id}`
    )
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoiceTipsList({
  tenantId,
  year,
  from,
  to,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${reportUrl}search/user/tips`, {
      tenantId,
      year,
      from,
      to,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}
